<div class="block bg-cover bg-center bg-[url('/assets/ankaadia_login_background.jpg')]" *appTranslate="let t">
  <div class="text-black w-full mx-auto h-screen flex flex-col justify-center items-center">
    @if (!isNil(termsAndConditions)) {
      <div id="wrapper" class="card w-(--consent-width) h-(--consent-height) mx-auto">
        <new-ui-terms-and-conditions
          [termsAndConditions]="termsAndConditions"
          (consentGiven)="processConsent($event)"
        />
      </div>
    }
  </div>
</div>
